import { apiClient } from '../../api/client';
import { ApiResponse } from '../../api/types';
import { GlobalConfigEntry } from './types';

export async function listGlobalConfig(): Promise<GlobalConfigEntry[]> {
  return (await apiClient.get<ApiResponse<GlobalConfigEntry[]>>('/api/v1/admin/global-config')).data.data;
}


export async function reloadGlobalConfig(): Promise<void> {
  await apiClient.post('/api/v1/admin/global-config/reload');
}
